import axios from '@jslib/axios'

export const getSMETicketList =  (params) => {
  return axios({
    method: 'get',
    url: '/admin/sme/ticket/list',
    params
  })
}
export const getSMETicketDetail =  (params) => {
  return axios({
    method: 'get',
    url: '/admin/sme/ticket/detail',
    params
  })
}
export const SMEAttachedCustomer =  (data) => {
  return axios({
    method: 'post',
    url: '/admin/sme/attached/customer',
    data
  })
}
export const editSMETicket =  (data) => {
  return axios({
    method: 'post',
    url: '/admin/sme/edit/request',
    data
  })
}
export const addSMETicket =  (data) => {
  return axios({
    method: 'post',
    url: '/admin/sme/add/request',
    data
  })
}
export const replySMEQuote =  (data) => {
  return axios({
    method: 'post',
    url: '/admin/sme/reply/quote',
    data
  })
}
export const replySMEQuoteCal =  (data) => {
  return axios({
    method: 'post',
    url: '/admin/sme/reply/quote/cal',
    data
  })
}
export const replySMEQuoteDetail =  (params) => {
  return axios({
    method: 'get',
    url: '/admin/sme/reply/quote/detail',
    params
  })
}
export const getNewSMEOption =  (params) => {
  return axios({
    method: 'get',
    url: '/admin/sme/option',
    params
  })
}
export const sendSMEPayment =  (data) => {
  return axios({
    method: 'post',
    url: '/admin/sme/payment/send',
    data
  })
}
export const getNewSMEQuoteDetail =  (params) => {
  return axios({
    method: 'get',
    url: '/admin/sme/quote/detail',
    params
  })
}
export const approveSMEPayment =  (data) => {
  return axios({
    method: 'post',
    url: '/admin/sme/payment/approve',
    data
  })
}
export const withdrawSMEQuote =  (data) => {
  return axios({
    method: 'post',
    url: '/admin/sme/withdraw/quote',
    data
  })
}
export const newSMEPolicyDetail =  (params) => {
  return axios({
    method: 'get',
    url: '/admin/sme/policy/detail',
    params
  })
}
export const editSMESummary =  (data) => {
  return axios({
    method: 'post',
    url: '/admin/sme/edit/summary',
    data
  })
}
